import { render, staticRenderFns } from "./l-add-key-popup.vue?vue&type=template&id=0aff7974&scoped=true"
import script from "./l-add-key-popup.vue?vue&type=script&lang=js"
export * from "./l-add-key-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff7974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aff7974')) {
      api.createRecord('0aff7974', component.options)
    } else {
      api.reload('0aff7974', component.options)
    }
    module.hot.accept("./l-add-key-popup.vue?vue&type=template&id=0aff7974&scoped=true", function () {
      api.rerender('0aff7974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mlocalization/views/popups/l-add-key-popup.vue"
export default component.exports